import Inputmask from 'inputmask/lib/inputmask';

export default {
  install(Vue) {
    Vue.directive('mask', {
      bind(el, binding) {
        Inputmask(binding.value).mask(el);
      }
    });
  }
};
